import { Badge } from "@xola/ui-kit";
import { getPaymentMethodName } from "common";
import React from "react";
import { PaymentMethod } from "types";
import { useSeller } from "../../../../hooks/useAccount";
import { Currency } from "../../../Common/Currency";
import { PaymentMethodIcon } from "../../../Common/PaymentMethodIcon";
import { TimelineItemReason } from "../TimelineItem";

interface TimelineContentProps {
    amount: number;
    method?: string;
    comment?: string;
    card?: any;
}

export default function PaymentTimelineItemContent({ amount, method, comment, card }: TimelineContentProps) {
    const seller = useSeller();
    return (
        <div className="flex flex-col space-y-2">
            <div className="flex flex-row space-x-2">
                <Currency shouldRemoveTrailingZeroes={false}>{amount}</Currency>
                {method && (
                    <Badge
                        color="secondary"
                        icon={<PaymentMethodIcon size="small" method={method ?? PaymentMethod.OTHER} />}
                        className="place-self-start self-start"
                    >
                        {getPaymentMethodName(seller, method)}
                        {card && <span>&nbsp;*{card?.last4}</span>}
                    </Badge>
                )}
            </div>
            {comment && <TimelineItemReason>{comment}</TimelineItemReason>}
        </div>
    );
}
